import React, { Component } from "react";
import { withRouter } from "react-router";
import Dropzone from 'react-dropzone'
import api from '../../utils/axiosApi'
import withReactContent from "sweetalert2-react-content";
import { Toast } from "../../utils/sweetalert";
import * as  XLSX from 'xlsx';


import {
  Row,
  Col,
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Label,
  Collapse
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


class Forms extends Component {
  constructor(props) {
    super(props) 
    this.state = {
      file : {
        name: ''
      },
      cityName:'',
      city:'',
      places:[],
      jsonExcel : [],
      arrayImgFile : [],
      arrayImgname: [],
      disabled: false
    }
    this.handleVerify=this.handleVerify.bind(this)
    this.handleSearchExtracity=this.handleSearchExtracity.bind(this)
  }

  handleChangecity= async (e) => {
    this.setState({cityName:e.target.value})
    if(e.target.value !== '') {
        try {
          debugger
            const resp = await api.get(`/ciudades/getcities?city=${e.target.value}`)
            if(resp.data.query === e.target.value) {
                this.setState({places:resp.data.data})
            }
        } catch (error) {
          this.setState({places:[]})
            //console.log(error)
        }
    } else {
      this.setState({places:[]})
    }
}

  handleSearchExtracity = async (e) =>{
    e.preventDefault()
    const MySwal = withReactContent(Toast)
    if(this.state.jsonExcel.length ===0 ) {
      await MySwal.fire({
        title: <p style={{fontSize: '15px'}}>Introduzca los archivos</p>,
        icon: 'error',
        
    })
    return
    }
    try {
      debugger
      this.setState({disabled: true})
      const formData = new FormData()
      formData.append('dataJson', JSON.stringify(this.state.jsonExcel))
      formData.append('cityId', this.state.city)
     const resp = await api.post(`/adminsplaces/detectExtraAct`, formData, {     
      headers: { 'content-type': 'multipart/form-data' }
    })
     /*
     const resp = await api.put(`/ciudades/editcities`, {data: JSON.stringify(this.state.jsonExcel)})
      */
      //console.log(resp)
    await MySwal.fire({
      title: <p style={{fontSize: '15px'}}>Actividad creado Exitosamente</p>,
      icon: 'success',
      
  })
    } catch (error) {
      //console.log(error)
    }
  this.setState({disabled: false})
  }
  handleVerify = async (e) =>{
    e.preventDefault()
    const formData = new FormData()
    const MySwal = withReactContent(Toast)
    if(this.state.jsonExcel.length ===0 ) {
      await MySwal.fire({
        title: <p style={{fontSize: '15px'}}>Introduzca los archivos</p>,
        icon: 'error',
        
    })
    return
    }
    try {
      
      this.setState({disabled: true})
       formData.append('dataJson', JSON.stringify(this.state.jsonExcel))
       for (const e of this.state.arrayImgFile) { 
        formData.append('photos', e, e.name);
     }
     const resp = await api.post(`/adminsplaces/verifyFromJson`, formData, {     
       headers: { 'content-type': 'multipart/form-data' }
     })
     /*
     const resp = await api.put(`/ciudades/editcities`, {data: JSON.stringify(this.state.jsonExcel)})
      */
      //console.log(resp)
    await MySwal.fire({
      title: <p style={{fontSize: '15px'}}>Actividad creado Exitosamente</p>,
      icon: 'success',
      
  })
    } catch (error) {
      //console.log(error)
    }
  this.setState({disabled: false})
  }

  handleSubmit = async (e) =>{
    e.preventDefault()
    const formData = new FormData()
    const MySwal = withReactContent(Toast)
    if(this.state.jsonExcel.length ===0 ) {
      await MySwal.fire({
        title: <p style={{fontSize: '15px'}}>Introduzca los archivos</p>,
        icon: 'error',
        
    })
    return
    }
    this.setState({disabled: true})
     formData.append('dataJson', JSON.stringify(this.state.jsonExcel))
     for (const e of this.state.arrayImgFile) { 
      formData.append('photos', e, e.name);
   }
    const resp = await api.post(`/adminsplaces/modifyFromJson`, formData, {     
      headers: { 'content-type': 'multipart/form-data' }
  })
  debugger
  if(resp.error) {
              await MySwal.fire({
                  title: <p style={{fontSize: '15px'}}>Actividad creado Exitosamente</p>,
                  icon: 'success',
                  
              })
  } else {
    await MySwal.fire({
      title: <p style={{fontSize: '15px'}}>Actividad creado Exitosamente</p>,
      icon: 'success',
      
  })
  }
  
  this.setState({disabled: false})
  }
  handleFile = (acceptedFiles) => {
    const noXLSX= acceptedFiles.find((e) => {
      return e.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })
    if(noXLSX) return
    this.setState({files: acceptedFiles[0]})
    debugger
    let hojas = []
    let reader = new FileReader()
    reader.readAsArrayBuffer(acceptedFiles[0])
    reader.onloadend= (e) => {
      var data = new Uint8Array(e.target.result)
      var workbook = XLSX.read(data, {type: 'array'})

      workbook.SheetNames.forEach(function (sheetName) {
        var XL_row_obj = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName])
        hojas.push({
          data: XL_row_obj,
          sheetName
        })
      })
      //console.log(hojas)
      this.setState({
        file: acceptedFiles[0],
        jsonExcel: hojas
      })
    }
  }
  handleImg = (acceptedFiles) => {
    const namesImg = []
    const noXLSX= acceptedFiles.find((e) => {
      namesImg.push(e.name)
      return !e.type.includes('image/')
    })
    debugger
    if(noXLSX) return
    this.setState({arrayImgFile: acceptedFiles,arrayImgname: namesImg })
  }
  Handleclick = (place,id) => {
    debugger
    this.setState({city:id, places:[], cityName:place})
  }
  render() {
    return (
      <>
      <div className="content">
        <Row>
          <Col md="12">
          <Card>
          <CardHeader>
          <CardTitle tag="h4">Actualizar Data</CardTitle>
          </CardHeader>
      <CardBody>
        <form onSubmit={this.handleSubmit}>
          <Row>
                    <Col className="pl-md-1" md="12">
                    <Label >Introduzca el archivo Xlsx</Label>
                    <Dropzone onDrop={this.handleFile}>
                      {({getRootProps, getInputProps}) => (
                        <section>
                          <div  className='dropZoneCont' {...getRootProps()}>
                            <input accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' {...getInputProps()} />
                            <p>{!this.state.file.name ? "Drag 'n' drop some files here, or click to select files" : this.state.file.name}</p>
                          </div>
                        </section>
                      )}
                    </Dropzone>
                    </Col>
                    <Col className="pl-md-1" md="12">
                    <Label >Coloque todas las imagenes aqui</Label>
                    <Dropzone onDrop={this.handleImg}>
                      {({getRootProps, getInputProps}) => (
                        <section>
                          <div  className='dropZoneCont' {...getRootProps()}>
                            <input accept="image/*" {...getInputProps()} />
                            <p>'Arrastre o presione aqui para elegir las imagenes'</p>
                          </div>
                        </section>
                      )}
                    </Dropzone>
                    <h6>Imagenes</h6>
                    <ul>
                      {this.state.arrayImgname.map(e=> {
                        return <li>{e}</li>
                      })}
                    </ul>
                    </Col>
                    
                  </Row>
                <Row>
                    <Col className="pl-md-1" md="12">
                    <Label >ciudad a verificar </Label>
                    <Row className='searchCont align-items-center m-0' style={{width: '100%'}}>
                    <Col xs={1} md={1} className='p-0 d-flex align-items-center justify-content-center'><FontAwesomeIcon icon='search'/></Col>
                    <Col  className='p-0'><input onClick={this.handleChangecity} onChange={this.handleChangecity} value={this.state.cityName} placeholder={'ciudad'} className='inputCity' type='text'></input></Col>
                    {/* <Col xs={0} md={0} className='p-0 d-flex align-items-center'><input value={date} onChange={handledate} className='inputDate d-none' type='date'></input></Col>*/}
                </Row>
                <Collapse className='optionsSearchCollapse' isOpen={(this.state.places.length!== 0)}>
                        <ul style={{zIndex: 300}} className='optionsSearch'> 
                        {this.state.places.map(e => {
                            var cityString = e.city
                            var country = e.country
                            const place = `${cityString}, ${country}`
                            return (
                            <li className='optionAutoComplete' onClick={() => {this.Handleclick(place,e._id)}}>{e.city},<span> {` `}{country}</span></li>
                    )})}
                    
                    </ul>
                </Collapse>
                    </Col>
                    
                  </Row>
          
          
          <Button disabled={this.state.disabled} color="primary" type="submit">
            Cargar Datos
          </Button>
          <Button disabled={this.state.disabled} color="primary" type="button" onClick={this.handleVerify}>
            validar Datos
          </Button>
          <Button disabled={this.state.disabled} color="secundary" type="button" onClick={this.handleSearchExtracity}>
            Verificar extra actividades
          </Button>
        </form>
      </CardBody>
    </Card>
          </Col>
        </Row>
      </div>
    </>
    )
  }
}


export default withRouter(Forms);
